import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-scroll to top on every route change.
 * Place inside <BrowserRouter> but outside <Routes>.
 * Cooperates with Lenis smooth-scroll instance exposed on window.__lenis.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Reset Lenis-managed scroll first (jumps without animation)
    if (window.__lenis && typeof window.__lenis.scrollTo === "function") {
      window.__lenis.scrollTo(0, { immediate: true });
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // Some browsers (Safari) ignore scrollTo on iframe-backed scrollers
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
}
